import React, { memo } from 'react';
import MaskedInput from 'react-text-mask';
import { number, func } from 'prop-types';
import styles from './CurrencyInput.less';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const numberMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  decimalSymbol: '.',
  decimalLimit: 2,
  integerLimit: 8,
});
const separator = ',';
const regex = new RegExp(`\\b${separator}\\b`, 'g');

const CurrencyInput = (props) => {
  const { value, onChange, ...rest } = props;

  const handleChange = (e) => {
    const newValue = e.target.value;
    const tempValue = newValue ? newValue.replace(regex, '') : newValue;
    onChange(+tempValue);
  };

  return (
    <div className={styles.currencyContainer}>
      <MaskedInput
        showMask
        mask={numberMask}
        defaultValue={value}
        guide={false}
        onChange={handleChange}
        inputtype="number"
        {...rest}
      />
    </div>
  );
};

CurrencyInput.propTypes = {
  value: number,
  onChange: func,
};

CurrencyInput.defaultProps = {
  value: 0,
  onChange: () => { },
};

function areEqual(prevProps, nextProps) {
  if (prevProps.value !== nextProps.value) return true;
  return false;
  /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */
}

export default memo(CurrencyInput, areEqual);
